require('vendor/animate/animate.css');
require('app/module/Application/hooks');
require('app/module/Application/extensions-jquery');
require('app/module/Application/css/general.less');
require('system.helper.fileDownload');

require('bootstrap');

var app = require('system.app'),
    moment = require('moment');

window.moment = moment; // set to global for shit plugins which require it

if (window.self !== window.top) {
    console.log('Loaded in iframe from:', document.referrer);

    $('#header').hide();
}

$(document).ready(function () {
    app.page.init({
        container: $('#main'),
        btnMoveBack: $('#btn-move-back-custom')
    }, function (page) {
        app.component.compile($(document));

        $(window).resize(function () {
            responsive();
            full_blocks();
        });

        responsive();
        full_blocks();

        // Responsibility
        function responsive() {
            var device = $('#responsive').css('content');
        }

        // Full Height Blocks
        function full_blocks() {
            var header = $('#header').outerHeight();
            var tb = $('#toolbar').outerHeight();
            var footer = $('#footer').outerHeight();
            var offset = header + tb + footer + 93;
            //$('.block-fh').css('height', $(window).height() - offset);
        }

        window.fileDownload = function (fileUrl, options) {
            $.fileDownload(fileUrl, options);
        };
    });
});